// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/components/scss/shapes.scss
// module id = 345
// module chunks = 2